import { render, staticRenderFns } from "./NonProportional.vue?vue&type=template&id=322aac73&scoped=true&"
import script from "./NonProportional.vue?vue&type=script&lang=js&"
export * from "./NonProportional.vue?vue&type=script&lang=js&"
import style0 from "./NonProportional.vue?vue&type=style&index=0&id=322aac73&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322aac73",
  null
  
)

export default component.exports